import './App.css'
import {Component} from 'react'
import Rules from './Rules'

const choicesList = [
  {
    id: 'ROCK',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/rock-image.png',
  },
  {
    id: 'SCISSORS',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/scissor-image.png',
  },
  {
    id: 'PAPER',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/paper-image.png',
  },
]

const scoreList = ['YOU LOSE', 'IT IS DRAW', 'YOU WON']

class App extends Component {
  state = {
    score: 0,
    isplaying: true,
    playerChoice: '',
    opponentChoice: '',
    currentScore: '',
  }

  tocheckscore = (playerChoice, opponentChoice) => {
    if (playerChoice === 0) {
      if (opponentChoice === 2) {
        return -1
      }
      if (opponentChoice === 1) {
        return 1
      }
      return 0
    }
    if (playerChoice === 1) {
      if (opponentChoice === 0) {
        return -1
      }
      if (opponentChoice === 2) {
        return 1
      }
      return 0
    }
    if (opponentChoice === 0) {
      return 1
    }
    if (opponentChoice === 1) {
      return -1
    }
    return 0
  }

  onplayerChoice = e => {
    const playerChoice = e
    console.log(e)
    const opponentChoice = Math.floor(Math.random() * 3)

    const scoretoincrease = this.tocheckscore(playerChoice, opponentChoice)
    console.log(playerChoice, opponentChoice, scoretoincrease)
    this.setState(prev => ({
      isplaying: !prev.isplaying,
      score: prev.score + scoretoincrease,
      playerChoice,
      opponentChoice,
      currentScore: scoretoincrease,
    }))
  }

  playAgain = () => {
    this.setState({isplaying: true})
  }

  render() {
    const {
      score,
      isplaying,
      playerChoice,
      opponentChoice,
      currentScore,
    } = this.state
    return (
      <div className="main_container">
        <div className="result_div">
          <div className="names_div">
            <h1 className="main_heading">
              ROCK
              <br /> PAPER
              <br /> SCISSORS
            </h1>
          </div>
          <div className="score_div">
            <p className="score">Score</p>
            <p className="score_p">{score}</p>
          </div>
        </div>
        {isplaying ? (
          <div className="playing_container">
            <div className="playing_buttons_div">
              <div className="playing_buttons_div_a">
                <div className="button_div">
                  <button
                    value="0"
                    type="button"
                    className="rockButton"
                    data-testid="rockButton"
                    onClick={() => this.onplayerChoice(0)}
                  >
                    <img
                      value="0"
                      alt={choicesList[0].id}
                      src={choicesList[0].imageUrl}
                    />
                  </button>
                </div>
                <div className="button_div">
                  <button
                    value="1"
                    type="button"
                    className="rockButton"
                    data-testid="scissorsButton"
                    onClick={() => this.onplayerChoice(1)}
                  >
                    <img
                      alt={choicesList[1].id}
                      src={choicesList[1].imageUrl}
                    />
                  </button>
                </div>
              </div>
              <div className="playing_buttons_div_b">
                <div className="button_div">
                  <button
                    value="2"
                    type="button"
                    className="rockButton"
                    data-testid="paperButton"
                    onClick={() => this.onplayerChoice(2)}
                  >
                    <img
                      alt={choicesList[2].id}
                      src={choicesList[2].imageUrl}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="result_view">
            <div className="result_view_1">
              <div className="result_view_1_1">
                <h1 className="you">YOU</h1>
                <img
                  alt="your choice"
                  src={choicesList[playerChoice].imageUrl}
                />
              </div>
              <div className="result_view_1_1">
                <h1 className="you">OPPONENT</h1>
                <img
                  alt="opponent choice"
                  src={choicesList[opponentChoice].imageUrl}
                />
              </div>
            </div>
            <p className="result">{scoreList[currentScore + 1]}</p>
            <div className="playagain">
              <button
                type="button"
                className="playagain_button"
                onClick={this.playAgain}
              >
                PLAY AGAIN
              </button>
            </div>
          </div>
        )}
        <Rules />
      </div>
    )
  }
}

export default App
